"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/font-family-resolver/font-family-resolver.ts
const values = {
	text: "var(--mantine-font-family)",
	mono: "var(--mantine-font-family-monospace)",
	monospace: "var(--mantine-font-family-monospace)",
	heading: "var(--mantine-font-family-headings)",
	headings: "var(--mantine-font-family-headings)"
};
function fontFamilyResolver(fontFamily) {
	if (typeof fontFamily === "string" && fontFamily in values) return values[fontFamily];
	return fontFamily;
}
//#endregion
export { fontFamilyResolver };

//# sourceMappingURL=font-family-resolver.mjs.map